module.exports = __webpack_public_path__ + "assets/src/style/img/svg/logo-here-now-groningen.svg?3ee782f21c8e7b254c4d7de9f9585644";